export default [
  {
    name: 'Home',
    link: { path: 'advisor-dashboard' },
  },
  {
    name: 'Research',
    links: [
      { name: 'Company Screener', path: 'advisordashboard/portfolio-builder', feature: 'Portfolio Builder' },
      { name: 'Fund Screener', path: 'advisor-dashboard/fund-screener-v2', feature: 'Fund Screener' },
      { name: 'Portfolio Designer', path: 'advisor-dashboard/design-portfolio-from-portfolio', feature: 'Portfolio Designer' },
    ],
  },
  {
    name: 'Reports',
    links: [
      { name: 'Prospects & Portfolios', path: 'advisor-dashboard/portfolios' },
      { name: 'Report Builder', path: 'advisor-dashboard/reports' },
      // { name: 'Client Groups', path: 'advisor/client-groups', useRouter: true },
    ],
  },
  {
    name: 'Journeys',
    links: [
      { name: 'VADIS', path: 'advisor-dashboard/direct-indexing', feature: 'FAFN Direct Indexing' },
      { name: 'Model Matchmaker', path: 'advisor-dashboard/model-matchmaker', feature: 'Model Matchmaker' },
      // { name: 'Workflows' },
    ],
  },
  // { name: 'Leads' },
];
